import React from 'react'
import AccountNav from './AccountNav'
import WatchlistListNav from '../watchlist/WatchlistListNav'

interface AccountSidebarPanelsProps {
  onWatchlist: boolean
  isAdmin: boolean
  onLogout: () => void
  onWatchlistBack: () => void
  onWatchlistDrill: () => void
}

/**
 * Animated account sidebar — root menu slides left to reveal watchlist list filters.
 */
const AccountSidebarPanels: React.FC<AccountSidebarPanelsProps> = ({
  onWatchlist,
  isAdmin,
  onLogout,
  onWatchlistBack,
  onWatchlistDrill,
}) => (
  <div className="w-full overflow-hidden">
    <div
      className={[
        'flex w-[200%] transition-transform duration-300 ease-out will-change-transform',
        onWatchlist ? '-translate-x-1/2' : 'translate-x-0',
      ].join(' ')}
    >
      <div className="w-1/2 shrink-0" aria-hidden={onWatchlist || undefined}>
        <AccountNav
          isAdmin={isAdmin}
          onLogout={onLogout}
          onWatchlistDrill={onWatchlistDrill}
        />
      </div>
      <div className="w-1/2 shrink-0" aria-hidden={!onWatchlist || undefined}>
        <WatchlistListNav onBack={onWatchlistBack} />
      </div>
    </div>
  </div>
)

export default AccountSidebarPanels
